
App.ready(() => App.coupons.init());


App.coupons = {

  init() {
    $(document)
      .off("change", ".js-coupons-status-select", App.coupons.status_changed)
      .on("change", ".js-coupons-status-select", App.coupons.status_changed)

      .off("click", ".js-btn-new-msg-coupon", this.add_coupon_clicked)
      .on("click", ".js-btn-new-msg-coupon", this.add_coupon_clicked)

      .off("click", ".js-attach-coupon-modal-remove-btn", this.remove_coupon_clicked)
      .on("click", ".js-attach-coupon-modal-remove-btn", this.remove_coupon_clicked);

    return this.init_attach_coupon();
  },


  init_attach_coupon() {
    $(document)
      .off("click", ".js-attach-coupon-modal-close-btn", this.add_coupon_close)
      .on("click", ".js-attach-coupon-modal-close-btn", this.add_coupon_close);
    return $(".js-attach-coupon-modal-close-btn").click();
  },


  status_changed(evt) {
    const params = new URLSearchParams(location.search);
    params.set("q", $(".js-search-filter input").val());
    params.set("status", $(this).val());
    return location.href = "/coupons?" + params.toString();
  },


  add_coupon_clicked: evt => {
    evt.preventDefault();

    // Don't close if the modal is clicked
    if ($(evt.target).closest(".js-attach-coupon-modal").length) { return false; }
    const $wrapper = $(evt.target).closest(".attach-coupon-wrapper");

    const $coupons_modal = $wrapper.find(".js-attach-coupon-modal");
    if ($coupons_modal.is(":visible")) {
      return $coupons_modal.fadeOut(200);
    } else {
      return $coupons_modal.fadeIn(200);
    }
  },


  add_coupon_close: evt => {
    let $select;
    const $wrapper = $(evt.target).closest(".attach-coupon-wrapper");
    const $coupons_modal = $wrapper.find(".js-attach-coupon-modal");
    const $button = $wrapper.find(".js-btn-new-msg-coupon");
    const $textarea = $($coupons_modal.attr("data-textarea"));

    if (($select = $coupons_modal.find("select")).val()) {
      // add data-coupon to textarea so Linkifying editor knows
      const url = $select.find("option:selected").attr("data-url");
      $textarea.attr("data-coupon-url", url);
      $wrapper.addClass("active");
    } else {
      $textarea.attr("data-coupon-url", null);
      $wrapper.removeClass("active");
    }

    $textarea.change();
    return $coupons_modal.fadeOut(200);
  },


  remove_coupon_clicked(evt) {
    const $wrapper = $(evt.target).closest(".attach-coupon-wrapper");
    const $coupons_modal = $wrapper.find(".js-attach-coupon-modal");
    return $coupons_modal.find("select").val("");
  }
};
